import { SLA_COMMS_LOGO_ID } from "@cart-client/constants/CartDeliverySpeed";
import { IStressComms, NativeLocalCart } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/js-utils";

export const getStressComms = (localCart?: NativeLocalCart | null): IStressComms | undefined => {
    if (isEmpty(localCart)) return;

    const { delivery_delay_message: slaText, delivery_delay_icon: slaLogo, delivery_delay_bg_color: slaBgColor } =
        localCart?.selectedAddress || {};

    return { slaText, slaLogo: slaLogo || SLA_COMMS_LOGO_ID, slaBgColor };
};
